export default {
  mixMode: 'Modo del Mix',
  referenceBudget: 'Presupuesto de Referencia ({unit})',
  grid: 'Grilla de Presupuestos ({count} presupuestos)',
  notFound: 'Esta simulación de presupuesto no existe o fue eliminada.',
  backToList: 'Volver al Simulador de Presupuesto',
  stillRunning: '{done} de {total} presupuestos calculados. El detalle se abre cuando todos los presupuestos estén listos.'
}
